export default __webpack_public_path__ + "static/freeTacos-61b3c5ed2ea9b4dc4266b72e15a31db6.svg";